import { selectedOutlineColor } from '@/editor/constant/entity';
import { getPureBoxes, IGetPureBoxesResult } from '@/editor/data/utils';
import { ISelected } from '@/editor/types';
import BoxesSelectedEntity from '@/editor/entities/selectedEntity/boxesSelectedEntity';

/** 移动与复制放置期间的选中轮廓框：无 params 时取数并首次创建，有 params 时更新位置 */
export class OperateSelectedBoxes {
  private _entity = new BoxesSelectedEntity();
  private _data: IGetPureBoxesResult | null = null;

  update(selected: ISelected, params?: { x: number; y: number; rotation: number }) {
    if (!params) {
      this._data = getPureBoxes(selected) ?? null;
    }

    if (!this._data) {
      this._entity.clear();
      return;
    }

    if (!this._entity.created) {
      this._entity.create({ ...this._data, linewidth: 1, color: selectedOutlineColor });
    } else if (params) {
      this._entity.update(params);
    }
  }

  clear() {
    this._entity.clear();
    this._data = null;
  }

  dispose() {
    this.clear();
    this._entity.dispose();
  }
}
